jQuery(function($)
{
  $('.footer .menu-item.menu-item-type-custom a').attr("target", "_blank");
});

jQuery(function($)
{
  function changeHeight(targetElem){
    	var count = $(targetElem).find('.menu-item').length;
      rows = Math.ceil(count / 3);
      targetElem.style.maxHeight = ((rows * 77) + 50) + 'px';
  }


    var subMenus = $('.main-menu .sub-menu');
    subMenus.each(function(){
        changeHeight(this);
    });

});

jQuery(function($)
{
  $('.slider-1-col').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  $('.slider-2-col').slick({
    dots: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.slider-3-col').slick({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.slider-4-col').slick({
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
